import { ClassTypeService } from './class-type.service';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import { FUZZY_SEARCH_DISTANCE } from '../../shared';
import { ClassType } from './class-type.model';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class ClassTypeTypeaheadService {

    // in milliseconds
    readonly DEBOUNCE_TIME = 300;

    constructor(private classTypeService: ClassTypeService) {
    }

    resultFormatter = (classType: any) => classType['name'];

    inputFormatter = (classType: any) => {
        return classType['name'];
    }

    search = (text$: Observable<String>) =>
        text$
            .debounceTime(this.DEBOUNCE_TIME)
            .distinctUntilChanged()
            .switchMap(term => {
                let formattedQuery = term;
                if (term.length === 0 ) {
                    term = ' ';
                }
                if (term) {
                    formattedQuery = term.split(/[ ]+/).reduce((acumQuery, token) => {
                        let fuzzyToken =  token !== '' ? token + '~' + FUZZY_SEARCH_DISTANCE : '';
                        return acumQuery + ' ' + fuzzyToken;
                    }, '');
                }
                return this.classTypeService
                .search({ query: formattedQuery })
                .switchMap((res: HttpResponse<ClassType[]>) => Observable.of(res.body));
            })
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/class-type/class-type.typeahead.service.ts